import { render, staticRenderFns } from "./CRFButtonGroup.vue?vue&type=template&id=52b84c38&"
import script from "./CRFButtonGroup.vue?vue&type=script&lang=js&"
export * from "./CRFButtonGroup.vue?vue&type=script&lang=js&"
import style0 from "./CRFButtonGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports